import { render, staticRenderFns } from "./LentaMessage.vue?vue&type=template&id=339bbe1a&scoped=true"
import script from "./LentaMessage.vue?vue&type=script&lang=js"
export * from "./LentaMessage.vue?vue&type=script&lang=js"
import style0 from "./LentaMessage.vue?vue&type=style&index=0&id=339bbe1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339bbe1a",
  null
  
)

export default component.exports